import React from 'react'
import i18n from 'live/services/i18n'
import FormGroup from 'live/components/forms/ui/form-group'
import ActionToggle from 'live/components/ui/action-toggle'
import HelpTip from 'live/components/ui/help-tip'
import styled from 'styled-components'
import _ from 'lodash'
import { StyledFormGroupContainer, ConfigSubtitle } from 'plugin-assets/shared/widget/components/styled'

export default class FormattingConfig extends React.Component<ConfigProps> {
    toggleDisableFormat = () => this.props.changeLayoutConfig('disableFormat', !this.props.config.disableFormat)
    changeFractionDigits = (value: number) => {
        let parsedValue = _.parseInt(value) || 0

        if (parsedValue > 20) parsedValue = 20
        else if (parsedValue < 0) parsedValue = 0

        const val = '' + parsedValue

        this.props.changeLayoutConfig('maximumFractionDigits', val)
        this.props.changeLayoutConfig('minimumFractionDigits', val)
    }

    render() {
        const { config } = this.props
        const { dark = false } = this.props

        return (
            <FormattingConfigContainer>
                <ConfigSubtitle>{i18n('Numeric Formatting')}</ConfigSubtitle>
                <ToggleRow>
                    <ActionToggle
                        type="checkbox"
                        name="disableFormat"
                        className={dark ? 'action-toggle--dark' : 'action-toggle'}
                        value={config.disableFormat}
                        active={!config.disableFormat}
                        onChange={this.toggleDisableFormat}
                    />
                    <label>
                        {i18n('Format (based on language)')}
                        <HelpTip
                            id="value-label-help"
                            placement="top"
                            text={i18n(`Formats the number based on the system language to make it more readable`)}
                        />
                    </label>
                </ToggleRow>
                {!config.disableFormat ? (
                    <StyledFormGroupContainer dark={dark}>
                        <FormGroup
                            type="number"
                            label={i18n('Precision (fraction digits)')}
                            name="fractionDigits"
                            value={config.minimumFractionDigits}
                            max={20}
                            min={0}
                            onChange={e => this.changeFractionDigits(e.target.value)}
                        />
                    </StyledFormGroupContainer>
                ) : null}
            </FormattingConfigContainer>
        )
    }
}

export const FormattingConfigContainer = styled.div`
    border-top: 1px solid ${({ theme }) => theme['gray-light']};
    padding: 0px 13px;
`

const ToggleRow = styled.div`
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    > label {
        font-size: 12px;
        font-family: ${({ theme }) => theme['font-regular']};
        margin-top: 2px;
    }

    > .action-toggle {
        top: 0;
    }
`

